import View from '../view';
import { Colors } from '../../../constants/theme';
import { FelaExtend } from '../../../types/fela';

type DividerProps = {
  extend?: FelaExtend;
};

export const Divider = ({ extend }: DividerProps) => (
  <View extend={[styles.divider, extend]} />
);

const styles = {
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: Colors.light.lightGrey,
  },
};
